import { startAppListening } from "@/store/utils";

import { acceptTermsSlice } from "../acceptTerms/acceptTerms.slice";

import { authSlice } from "..";

startAppListening({
  actionCreator: authSlice.actions.logout,
  effect: (action, { dispatch }) => {
    dispatch(acceptTermsSlice.actions.toogleTerms(false));
  }
});

startAppListening({
  actionCreator: authSlice.actions.setCredentials,
  effect: (action, { dispatch }) => {
    dispatch(acceptTermsSlice.actions.toogleTerms(true));
  }
});
